
<div class="storage-type-share-panel">
  <div
    v-for="(item, index) in mountedFSList"
    :key="`storage-type-${index}`"
    class="grid grid-cols-4 gap-x-2"
  >
    <v-autocomplete
      :id="`rde-input-storage-share-name-${index}`"
      v-model="item.pvcName"
      :items="genOptions(item.pvcName)"
      :label="`* ${$t('workspace_rde.rde_detail.label.file_storage_pvc')}`"
      small-chips
      :placeholder="
        $t('workspace_rde.rde_detail.placeholder.select_file_storage_pvc')
      "
      class="app-g-autocomplete-v2"
      outlined
      dense
      :rules="[rules.required]"
    />
    <Input
      :id="`rde-input-storage-share-aliasName-${index}`"
      v-model="item.aliasName"
      :placeholder="$t('workspace_rde.rde_detail.placeholder.enter_dir_name')"
      :rules="[rules.required, rules.name, validateDuplicate]"
      :label="`* ${$t('workspace_rde.rde_detail.label.directory_name')}`"
      appendClass="input-text-field-v2 text-details"
    />
    <div class="flex w-3">
      <v-icon class="h-6 mt-1" @click="handleRemoveClick(index)">
        mdi-close
      </v-icon>
    </div>
  </div>
  <Button class="add-button" size="md" @click="handleAddClick">
    <v-icon>mdi-plus</v-icon>
    {{ $t("workspace_rde.rde_detail.button.add_storage_share") }}
  </Button>
</div>
